module.exports = __webpack_public_path__ + "img/credit-sec-logo.102ebf59.svg";